(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2693],{

/***/ 95719:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thi-gplx/[type]/[license]",
      function () {
        return __webpack_require__(4542);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ License; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25617);
/* harmony import */ var _assets_licenseDetails_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71798);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82771);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85307);
/* harmony import */ var _redux_slices_gplx_quiz__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44326);
/* harmony import */ var _sections_gplx_HomeCar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52584);
/* harmony import */ var _sections_gplx_HomeMotoBike__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74445);
/* harmony import */ var _utils_checkLicense__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51753);
/* harmony import */ var _utils_licenses__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50168);
/* eslint-disable react/prop-types */ 









License.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function License(param) {
    var license = param.license, type = param.type, licenseTypes = param.licenseTypes;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var licenseIndex = (0,_utils_checkLicense__WEBPACK_IMPORTED_MODULE_9__/* .checkLicense */ .X)(license);
    var _licenseIndex = _assets_licenseDetails_json__WEBPACK_IMPORTED_MODULE_2__[licenseIndex], licenseName = _licenseIndex.name, time = _licenseIndex.time, correctAnswers = _licenseIndex.correctAnswers, totalExams = _licenseIndex.totalExams;
    dispatch((0,_redux_slices_gplx_quiz__WEBPACK_IMPORTED_MODULE_5__/* .setLicenseData */ .xr)({
        licenseIndex: licenseIndex,
        licenseName: licenseName,
        licenseRequirement: {
            time: time,
            correctAnswers: correctAnswers
        },
        totalExams: totalExams
    }));
    if (type === _utils_licenses__WEBPACK_IMPORTED_MODULE_8__/* .licenseDataArray[4][0] */ .J[4][0]) {
        var title = "Thi GPLX \xf4 t\xf4 - Hạng bằng ".concat(licenseName);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: title,
            description: title,
            imagePath: "/slider/lo-trinh-hoc-xe-oto.jpg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_gplx_HomeCar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                licenseTypes: licenseTypes
            })
        });
    } else {
        var title1 = "Thi GPLX xe m\xe1y - Hạng bằng ".concat(licenseName);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: title1,
            description: title1,
            imagePath: "/slider/lo-trinh-hoc-xe-may.jpg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_gplx_HomeMotoBike__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                licenseTypes: licenseTypes
            })
        });
    }
}


/***/ }),

/***/ 51753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ checkLicense; }
/* harmony export */ });
function checkLicense(str) {
    if (str.toUpperCase() === "A1") {
        return 0;
    } else if (str.toUpperCase() === "A2") {
        return 1;
    } else if (str.toUpperCase() === "A3") {
        return 2;
    } else if (str.toUpperCase() === "A4") {
        return 3;
    } else if (str.toUpperCase() === "B1") {
        return 4;
    } else if (str.toUpperCase() === "B2") {
        return 5;
    } else if (str.toUpperCase() === "C") {
        return 6;
    } else if (str.toUpperCase() === "D") {
        return 7;
    } else if (str.toUpperCase() === "E") {
        return 8;
    } else if (str.toUpperCase() === "F") {
        return 9;
    }
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,1160,3362,6093,3559,1553,7207,9774,2888,179], function() { return __webpack_exec__(95719); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);